(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement-bar__message'));
      if (this.messages.length < 2) return;

      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.index = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      this.play();
    }

    disconnectedCallback() {
      this.pause();
    }

    play() {
      if (this.timer) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    pause() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const current = this.messages[this.index];
      this.index = (this.index + 1) % this.messages.length;
      const next = this.messages[this.index];

      current.hidden = true;
      next.hidden = false;
      if (!this.reducedMotion) {
        next.classList.remove('is-entering');
        void next.offsetWidth;
        next.classList.add('is-entering');
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    const toc = document.querySelector('[data-art-toc]');
    const body = document.querySelector('[data-art-body]');
    if (!toc || !body) return;

    const normalize = (text) =>
      text.replace(/\s+/g, ' ').trim().toLowerCase().replace(/[.:!?]+$/, '');
    const title = normalize(document.querySelector('[data-art-title]')?.textContent || '');

    // Only real, non-empty H2s; never the article title repeated inside the body; never a heading repeated back to back.
    const entries = [];
    let previous = '';
    body.querySelectorAll('h2').forEach((heading) => {
      const text = heading.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;
      const key = normalize(text);
      if (key === title || key === previous) return;
      previous = key;
      entries.push({ heading, text });
    });

    if (entries.length < 4) {
      toc.remove();
      return;
    }

    const slug = (text) =>
      text
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60) || 'section';

    const used = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
    const list = toc.querySelector('[data-art-toc-list]');

    entries.forEach(({ heading, text }) => {
      if (!heading.id) {
        const base = slug(text);
        let id = base;
        let count = 2;
        while (used.has(id)) id = base + '-' + count++;
        heading.id = id;
        used.add(id);
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = text;
      item.appendChild(link);
      list.appendChild(item);
    });

    const count = toc.querySelector('[data-art-toc-count]');
    if (count && toc.dataset.countTemplate) {
      count.textContent = toc.dataset.countTemplate.replace('__COUNT__', entries.length);
    }
    toc.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ask-careway"]) return;
  try {
    
  class AskCarewayForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      // Move focus to a server-side error or the success message when the page loads with one.
      const target = this.querySelector('[data-autofocus]');
      if (target) target.focus();

      this.loadProductContext();

      const validated = this.form.querySelectorAll('[data-validate]');
      if (!validated.length) return;

      // Calm, explanatory messages replace the browser's own bubbles once this script is running.
      this.form.noValidate = true;
      this.summary = this.form.querySelector('[data-summary]');
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.form.addEventListener('input', (event) => this.clear(event.target));
      this.form.addEventListener('change', (event) => this.clear(event.target));
    }

    // When opened from a product page (?product=handle), confirm which product the question is about
    // and send its name and link with the answers. Only the product handle travels in the URL.
    async loadProductContext() {
      const holder = this.form.querySelector('[data-context]');
      const params = new URLSearchParams(window.location.search);
      const handle = params.get('product');
      if (!holder) return;
      if (!handle) {
        this.loadCollectionContext(holder, params.get('collection'));
        return;
      }

      try {
        const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const product = await response.json();
        if (!product || !product.title) return;

        holder.querySelector('[data-context-name]').textContent = product.title;
        const title = this.form.querySelector('[data-context-title]');
        const link = this.form.querySelector('[data-context-link]');
        title.value = product.title;
        title.disabled = false;
        link.value = window.location.origin + product.url;
        link.disabled = false;
        holder.hidden = false;
      } catch (error) {
        // No context is fine: the form simply works as it always did.
      }
    }

    // Opened from a collection (?collection=handle): the handle is checked against the store's own
    // public collection list, so only a real collection's title and link are ever shown or sent.
    async loadCollectionContext(holder, handle) {
      if (!handle) return;

      try {
        const response = await fetch('/collections.json?limit=250', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        const collection = (data.collections || []).find((item) => item.handle === handle);
        if (!collection || !collection.title) return;

        holder.querySelector('.ask-context__label').textContent = holder.dataset.collectionLabel;
        holder.querySelector('[data-context-name]').textContent = collection.title;
        const title = this.form.querySelector('[data-context-collection-title]');
        const link = this.form.querySelector('[data-context-collection-link]');
        title.value = collection.title;
        title.disabled = false;
        link.value = window.location.origin + '/collections/' + collection.handle;
        link.disabled = false;
        holder.hidden = false;
      } catch (error) {
        // No context is fine: the form simply works as it always did.
      }
    }

    controls(key) {
      return Array.from(this.form.querySelectorAll('[data-validate="' + key + '"]'));
    }

    problem(key) {
      const controls = this.controls(key);
      if (!controls.length) return null;
      const first = controls[0];

      if (first.type === 'radio') {
        return controls.some((control) => control.checked) ? null : 'missing';
      }
      const value = first.value.trim();
      if (!value) return 'missing';
      if (first.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'invalid';
      return null;
    }

    show(key, kind) {
      const message = this.form.querySelector('[data-error-for="' + key + '"]');
      const controls = this.controls(key);
      if (message) {
        if (kind === 'invalid' && message.dataset.messageInvalid) message.textContent = message.dataset.messageInvalid;
        else if (message.dataset.messageMissing) message.textContent = message.dataset.messageMissing;
        message.hidden = false;
      }
      controls.forEach((control) => control.setAttribute('aria-invalid', 'true'));
    }

    clear(control) {
      const key = control && control.dataset ? control.dataset.validate : null;
      if (!key) return;
      const message = this.form.querySelector('[data-error-for="' + key + '"]');
      if (message) message.hidden = true;
      this.controls(key).forEach((item) => item.removeAttribute('aria-invalid'));
      if (this.summary && !this.form.querySelector('[data-error-for]:not([hidden])')) this.summary.hidden = true;
    }

    onSubmit(event) {
      let firstInvalid = null;
      const keys = Array.from(new Set(Array.from(this.form.querySelectorAll('[data-validate]')).map((el) => el.dataset.validate)));
      keys.forEach((key) => {
        const kind = this.problem(key);
        if (kind) {
          this.show(key, kind);
          if (!firstInvalid) firstInvalid = this.controls(key)[0];
        } else {
          this.clear(this.controls(key)[0]);
        }
      });

      if (firstInvalid) {
        // Stop here so Shopify's own spam check is never triggered for an incomplete form.
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.summary) this.summary.hidden = false;
        firstInvalid.focus();
      }
      // Otherwise leave the submission entirely to Shopify's native form handling.
    }
  }

  if (!customElements.get('ask-careway-form')) customElements.define('ask-careway-form', AskCarewayForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-dialog]');
      this.content = this.querySelector('[data-content]');
      this.alertEl = this.querySelector('[data-alert]');
      this.live = this.querySelector('[data-live]');
      this.busy = false;
      this.closing = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
        else if (event.target.closest('[data-cart-close]')) this.close();
      });
      this.dialog.addEventListener('close', () => this.finishClose());

      this.content.addEventListener('click', (event) => this.onContentClick(event));
      this.content.addEventListener('change', (event) => this.onQuantityInput(event));
      this.content.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.matches('[data-qty-input]')) {
          event.preventDefault();
          this.commitInput(event.target);
        }
      });

      this.syncCount(this.dataset.itemCount);
    }

    open(opener) {
      this.opener = opener || document.activeElement;
      if (this.dialog.open && !this.closing) return;
      this.closing = false;
      const gap = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--cart-scrollbar-gap', gap + 'px');
      document.documentElement.classList.add('cart-drawer-open');
      if (!this.dialog.open) this.dialog.showModal();
      requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
    }

    close() {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      this.dialog.classList.remove('is-open');
      if (this.reduced.matches) {
        this.dialog.close();
        return;
      }
      const panel = this.querySelector('[data-panel]');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.dialog.close();
      };
      panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 500);
    }

    finishClose() {
      this.closing = false;
      this.dialog.classList.remove('is-open');
      document.documentElement.classList.remove('cart-drawer-open');
      document.documentElement.style.removeProperty('--cart-scrollbar-gap');
      this.setAlert('');
      const target = this.opener && this.opener.isConnected ? this.opener : document.querySelector('[data-cart-toggle]');
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }

    setAlert(message) {
      this.alertEl.textContent = message;
      this.alertEl.hidden = !message;
    }

    announce(message) {
      this.live.textContent = '';
      setTimeout(() => {
        this.live.textContent = message;
      }, 50);
    }

    setBusy(state) {
      this.busy = state;
      this.content.setAttribute('aria-busy', String(state));
    }

    syncCount(count) {
      const total = parseInt(count, 10) || 0;
      this.dataset.itemCount = String(total);
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = String(total);
        badge.hidden = total === 0;
      });
      document.querySelectorAll('[data-cart-count-label]').forEach((label) => {
        label.textContent = total > 0 ? ' (' + total + ')' : '';
      });
    }

    render(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-content]');
      const incoming = doc.querySelector('cart-drawer');
      if (!next || !incoming) return;

      const active = document.activeElement;
      const inside = this.content.contains(active);
      const focusKey = inside ? active.closest('[data-focus]')?.dataset.focus || active.dataset.focus : null;

      this.content.innerHTML = next.innerHTML;
      this.querySelector('[data-drawer-count]').innerHTML = incoming.querySelector('[data-drawer-count]').innerHTML;
      this.querySelector('[data-drawer-count]').hidden = incoming.querySelector('[data-drawer-count]').hidden;
      this.syncCount(incoming.dataset.itemCount);

      if (inside) {
        let target = null;
        if (focusKey) {
          target = Array.from(this.content.querySelectorAll('[data-focus]')).find((el) => el.dataset.focus === focusKey);
        }
        if (!target) target = this.content.querySelector('[data-qty-input], [data-focus="empty-action"], [data-focus="checkout"]');
        (target || this.querySelector('[data-cart-close]')).focus({ preventScroll: true });
      }
    }

    async fetchSection() {
      const response = await fetch(this.dataset.rootUrl + '?sections=cart-drawer', { headers: { Accept: 'application/json' } });
      const data = await response.json();
      return data['cart-drawer'];
    }

    async refresh() {
      try {
        this.render(await this.fetchSection());
      } catch (error) {
        /* keep what is shown; the next action will re-sync */
      }
    }

    errorMessage(data) {
      return (data && (data.description || data.message)) || this.dataset.errorGeneric;
    }

    async add(form, submitter) {
      if (this.busy) return;
      this.setBusy(true);
      this.setAlert('');
      submitter?.setAttribute('data-loading', '');
      submitter?.setAttribute('aria-busy', 'true');

      try {
        const body = new FormData(form);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', window.location.pathname);
        const response = await fetch(this.dataset.addUrl, { method: 'POST', body, headers: { Accept: 'application/json' } });
        const data = await response.json();

        if (!response.ok || data.status) {
          await this.refresh();
          this.setAlert(this.errorMessage(data));
          this.open(submitter);
        } else {
          this.render(data.sections['cart-drawer']);
          this.open(submitter);
          this.announce(this.dataset.msgAdded);
        }
      } catch (error) {
        await this.refresh();
        this.setAlert(this.dataset.errorNetwork);
        this.open(submitter);
      } finally {
        this.setBusy(false);
        submitter?.removeAttribute('data-loading');
        submitter?.removeAttribute('aria-busy');
      }
    }

    async change(line, quantity, message) {
      if (this.busy) return;
      this.setBusy(true);
      this.setAlert('');

      try {
        const response = await fetch(this.dataset.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line, quantity, sections: 'cart-drawer', sections_url: window.location.pathname }),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          await this.refresh();
          this.setAlert(this.errorMessage(data));
        } else {
          this.render(data.sections['cart-drawer']);
          this.announce(message);
        }
      } catch (error) {
        await this.refresh();
        this.setAlert(this.dataset.errorNetwork);
      } finally {
        this.setBusy(false);
      }
    }

    onContentClick(event) {
      const step = event.target.closest('[data-qty-step]');
      if (step) {
        if (step.getAttribute('aria-disabled') === 'true') return;
        const input = Array.from(this.content.querySelectorAll('[data-qty-input]')).find((el) => el.dataset.line === step.dataset.line);
        const current = parseInt(input?.dataset.original, 10) || 1;
        const next = current + parseInt(step.dataset.qtyStep, 10);
        if (next >= 1) this.change(step.dataset.line, next, this.dataset.msgUpdated);
        return;
      }
      const remove = event.target.closest('[data-remove]');
      if (remove) this.change(remove.dataset.line, 0, this.dataset.msgRemoved);
    }

    onQuantityInput(event) {
      if (event.target.matches('[data-qty-input]')) this.commitInput(event.target);
    }

    commitInput(input) {
      const original = parseInt(input.dataset.original, 10) || 1;
      const value = parseInt(input.value, 10);
      if (!(value >= 1)) {
        input.value = String(original);
        return;
      }
      if (value !== original) this.change(input.dataset.line, value, this.dataset.msgUpdated);
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  // Only the theme's own Add to cart buttons are intercepted. Shop Pay, "More payment
  // options" and any other dynamic checkout button are left completely alone.
  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || !submitter.matches('[data-cart-add]')) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.add !== 'function') return;
    event.preventDefault();
    drawer.add(event.target, submitter);
  });

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const toggle = event.target.closest('[data-cart-toggle]');
    if (!toggle) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(toggle);
    drawer.refresh();
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) document.querySelector('cart-drawer')?.refresh();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionPage extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-filter-dialog]');
      this.opener = null;
      this.closing = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.setupSort();
      this.setupFilters();
      this.setupHoverImages();
    }

    setupSort() {
      const select = this.querySelector('[data-sort-select]');
      const form = this.querySelector('[data-sort-form]');
      if (!select || !form) return;
      select.addEventListener('change', () => form.submit());
    }

    setupFilters() {
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      const form = this.dialog.querySelector('form');
      if (form) {
        form.addEventListener('submit', () => {
          form.querySelectorAll('input[type="number"]').forEach((input) => {
            if (input.value === '') input.disabled = true;
          });
        });
      }

      this.querySelectorAll('[data-open-filters]').forEach((button) => {
        button.hidden = false;
        button.addEventListener('click', () => this.open(button));
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-close-filters]')) this.close();
      });
      this.dialog.addEventListener('close', () => this.finishClose());
    }

    open(opener) {
      this.opener = opener;
      this.closing = false;
      document.documentElement.classList.add('cp-drawer-open');
      if (!this.dialog.open) this.dialog.showModal();
      requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
    }

    close() {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      this.dialog.classList.remove('is-open');
      if (this.reduced.matches) {
        this.dialog.close();
        return;
      }
      const panel = this.querySelector('[data-filter-panel]');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.dialog.close();
      };
      panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 500);
    }

    finishClose() {
      this.closing = false;
      this.dialog.classList.remove('is-open');
      document.documentElement.classList.remove('cp-drawer-open');
      if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
    }

    // Second product image loads only when someone actually points at a card.
    setupHoverImages() {
      if (!window.matchMedia('(hover: hover)').matches) return;
      const load = (event) => {
        const card = event.target.closest && event.target.closest('.cc');
        if (!card) return;
        const image = card.querySelector('[data-hover-src]');
        if (!image || image.dataset.requested) return;
        image.dataset.requested = 'true';
        image.addEventListener('load', () => image.classList.add('is-ready'), { once: true });
        image.sizes = image.dataset.hoverSizes;
        image.srcset = image.dataset.hoverSrcset;
        image.src = image.dataset.hoverSrc;
      };
      this.addEventListener('pointerover', load);
      this.addEventListener('focusin', load);
    }
  }

  if (!customElements.get('collection-page')) customElements.define('collection-page', CollectionPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  class CarewayContactForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      // Move focus to a server-side error or the success message when the page loads with one.
      const target = this.querySelector('[data-autofocus]');
      if (target) target.focus();

      if (!this.form.querySelector('[data-validate]')) return;

      // Calm, explanatory messages replace the browser's own bubbles once this script is running.
      this.form.noValidate = true;
      this.summary = this.form.querySelector('[data-summary]');
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.form.addEventListener('input', (event) => this.clear(event.target));
    }

    control(key) {
      return this.form.querySelector('[data-validate="' + key + '"]');
    }

    problem(key) {
      const control = this.control(key);
      if (!control) return null;
      const value = control.value.trim();
      if (!value) return 'missing';
      if (control.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'invalid';
      return null;
    }

    show(key, kind) {
      const message = this.form.querySelector('[data-error-for="' + key + '"]');
      if (message) {
        if (kind === 'invalid' && message.dataset.messageInvalid) message.textContent = message.dataset.messageInvalid;
        else if (message.dataset.messageMissing) message.textContent = message.dataset.messageMissing;
        message.hidden = false;
      }
      this.control(key).setAttribute('aria-invalid', 'true');
    }

    clear(control) {
      const key = control && control.dataset ? control.dataset.validate : null;
      if (!key) return;
      const message = this.form.querySelector('[data-error-for="' + key + '"]');
      if (message) message.hidden = true;
      control.removeAttribute('aria-invalid');
      if (this.summary && !this.form.querySelector('[data-error-for]:not([hidden])')) this.summary.hidden = true;
    }

    onSubmit(event) {
      let firstInvalid = null;
      this.form.querySelectorAll('[data-validate]').forEach((control) => {
        const key = control.dataset.validate;
        const kind = this.problem(key);
        if (kind) {
          this.show(key, kind);
          if (!firstInvalid) firstInvalid = control;
        } else {
          this.clear(control);
        }
      });

      if (firstInvalid) {
        // Stop here so Shopify's own spam check is never triggered for an incomplete form.
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.summary) this.summary.hidden = false;
        firstInvalid.focus();
      }
      // Otherwise leave the submission entirely to Shopify's native form handling.
    }
  }

  if (!customElements.get('careway-contact-form')) customElements.define('careway-contact-form', CarewayContactForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.searchToggle = this.querySelector('.site-header__search-toggle');
      this.searchPanel = this.querySelector('.site-header__search-panel');
      this.items = Array.from(this.querySelectorAll('[data-nav-item]'));
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.openItem = null;
      this.hoverTimer = null;
      this.leaveTimer = null;

      this.searchToggle?.addEventListener('click', () => {
        this.closePanels();
        this.toggle(this.searchToggle, this.searchPanel);
      });

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-nav-trigger]');
        const panel = item.querySelector('[data-nav-panel]');
        trigger.addEventListener('click', (event) => this.onTriggerClick(item, event));
        trigger.addEventListener('keydown', (event) => this.onTriggerKey(item, event));
        // Panel images stay unloaded until someone shows interest, then load ahead of the panel opening.
        const warm = () => panel.querySelectorAll('img[loading="lazy"]').forEach((image) => (image.loading = 'eager'));
        item.addEventListener('pointerenter', (event) => {
          warm();
          if (event.pointerType === 'mouse' && this.desktop.matches) this.scheduleOpen(item);
        });
        item.addEventListener('focusin', warm, { once: true });
        item.addEventListener('touchstart', warm, { once: true, passive: true });
        item.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') this.scheduleClose(item);
        });
        item.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !item.contains(event.relatedTarget)) this.closePanel(item);
        });
        panel.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.stopPropagation();
            this.closePanel(item);
            trigger.focus();
          }
        });
      });

      this.querySelector('[data-nav-scrim]')?.addEventListener('click', () => this.closePanels());
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closePanels();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (this.openItem) {
          const item = this.openItem;
          this.closePanel(item);
          item.querySelector('[data-nav-trigger]').focus();
        }
        this.close(this.searchToggle, this.searchPanel);
      });
      this.desktop.addEventListener('change', () => {
        if (!this.desktop.matches) this.closePanels();
        else this.closeMobile();
      });

      this.setupMobile();
    }

    /* ---------- Desktop mega panels ---------- */
    clearTimers() {
      clearTimeout(this.hoverTimer);
      clearTimeout(this.leaveTimer);
    }

    scheduleOpen(item) {
      clearTimeout(this.leaveTimer);
      if (this.openItem === item) return;
      clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout(() => this.openPanel(item, false), this.openItem ? 60 : 120);
    }

    scheduleClose(item) {
      clearTimeout(this.hoverTimer);
      clearTimeout(this.leaveTimer);
      if (item.pinned) return;
      this.leaveTimer = setTimeout(() => {
        if (this.openItem === item && !item.pinned) this.closePanel(item);
      }, 320);
    }

    openPanel(item, pinned) {
      if (this.openItem && this.openItem !== item) this.closePanel(this.openItem);
      const panel = item.querySelector('[data-nav-panel]');
      const trigger = item.querySelector('[data-nav-trigger]');
      this.close(this.searchToggle, this.searchPanel);
      this.style.setProperty('--header-bottom', Math.round(this.getBoundingClientRect().bottom) + 'px');
      item.token = (item.token || 0) + 1;
      panel.hidden = false;
      requestAnimationFrame(() => panel.classList.add('is-open'));
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      item.pinned = pinned;
      this.openItem = item;
      this.classList.add('has-open-panel');
    }

    closePanel(item) {
      if (!item.classList.contains('is-open')) return;
      const panel = item.querySelector('[data-nav-panel]');
      const trigger = item.querySelector('[data-nav-trigger]');
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      item.pinned = false;
      if (this.openItem === item) {
        this.openItem = null;
        this.classList.remove('has-open-panel');
      }
      panel.classList.remove('is-open');
      const token = item.token;
      const hide = () => {
        if (item.token === token && !item.classList.contains('is-open')) panel.hidden = true;
      };
      if (this.reduced.matches) hide();
      else setTimeout(hide, 220);
    }

    closePanels() {
      this.clearTimers();
      this.items.forEach((item) => this.closePanel(item));
    }

    onTriggerClick(item, event) {
      const viaKeyboard = event.detail === 0;
      this.clearTimers();
      if (this.openItem === item) {
        if (item.pinned || viaKeyboard) this.closePanel(item);
        else item.pinned = true;
        return;
      }
      this.openPanel(item, true);
      if (viaKeyboard) this.focusFirst(item);
    }

    onTriggerKey(item, event) {
      const trigger = event.currentTarget;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.clearTimers();
        if (this.openItem !== item) this.openPanel(item, true);
        this.focusFirst(item);
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        const links = Array.from(this.querySelectorAll('.site-header__nav-link'));
        const next = links[links.indexOf(trigger) + (event.key === 'ArrowRight' ? 1 : -1)];
        if (!next) return;
        event.preventDefault();
        next.focus();
        const nextItem = next.closest('[data-nav-item]');
        if (this.openItem && nextItem) this.openPanel(nextItem, true);
        else if (this.openItem) this.closePanel(this.openItem);
      }
    }

    focusFirst(item) {
      const first = item.querySelector('[data-nav-panel] a[href]');
      if (first) first.focus();
    }

    toggle(button, panel) {
      if (!button || !panel) return;
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      isOpen ? this.close(button, panel) : this.open(button, panel);
    }

    open(button, panel) {
      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      if (panel === this.searchPanel) panel.querySelector('input[type="search"]')?.focus();
    }

    close(button, panel) {
      if (!button || !panel) return;
      button.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }

    /* ---------- Mobile menu (native dialog with drill-down) ---------- */
    setupMobile() {
      this.mnav = this.querySelector('[data-mnav]');
      this.menuToggle = this.querySelector('.site-header__menu-toggle');
      if (!this.mnav || !this.menuToggle || typeof this.mnav.showModal !== 'function') return;

      this.viewport = this.mnav.querySelector('[data-mnav-viewport]');
      this.views = Array.from(this.mnav.querySelectorAll('[data-mnav-view]'));
      this.lastRow = null;
      this.mnavClosing = false;
      this.menuToggle.hidden = false;
      this.menuToggle.addEventListener('click', () => this.openMobile());

      this.mnav.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeMobile();
      });
      this.mnav.addEventListener('click', (event) => {
        if (event.target === this.mnav || event.target.closest('[data-mnav-close]')) return this.closeMobile();
        const go = event.target.closest('[data-mnav-go]');
        if (go) return this.showView(go.dataset.mnavGo, go);
        if (event.target.closest('[data-mnav-back]')) this.showView('root');
      });
      this.mnav.addEventListener('close', () => this.finishMobile());
      this.mnav.addEventListener('keydown', (event) => {
        if (event.key === 'Tab') this.trapTab(event);
      });
    }

    // Keeps Tab and Shift+Tab cycling inside the menu, including its current drill-down screen.
    trapTab(event) {
      const focusable = Array.from(this.mnav.querySelectorAll('a[href], button, input')).filter(
        (element) =>
          !element.disabled &&
          !element.closest('[inert]') &&
          element.getClientRects().length > 0 &&
          getComputedStyle(element).visibility !== 'hidden'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || !this.mnav.contains(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !this.mnav.contains(active))) {
        event.preventDefault();
        first.focus();
      }
    }

    showView(id, from) {
      this.viewport.dataset.active = id;
      this.views.forEach((view) => {
        const active = view.dataset.mnavView === id;
        view.classList.toggle('is-active', active);
        view.inert = !active;
      });
      if (id === 'root') {
        (this.lastRow || this.mnav.querySelector('[data-mnav-close]'))?.focus({ preventScroll: true });
      } else {
        this.lastRow = from || this.lastRow;
        this.views.find((view) => view.dataset.mnavView === id)?.querySelector('[data-mnav-back]')?.focus({ preventScroll: true });
      }
    }

    openMobile() {
      if (this.mnav.open && !this.mnavClosing) return;
      this.closePanels();
      this.close(this.searchToggle, this.searchPanel);
      this.mnavClosing = false;
      this.lastRow = null;
      this.viewport.dataset.active = 'root';
      this.views.forEach((view) => {
        const root = view.dataset.mnavView === 'root';
        view.classList.toggle('is-active', root);
        view.inert = !root;
      });
      document.documentElement.classList.add('mnav-open');
      this.menuToggle.setAttribute('aria-expanded', 'true');
      if (!this.mnav.open) this.mnav.showModal();
      requestAnimationFrame(() => requestAnimationFrame(() => this.mnav.classList.add('is-open')));
    }

    closeMobile() {
      if (!this.mnav || !this.mnav.open || this.mnavClosing) return;
      this.mnavClosing = true;
      this.mnav.classList.remove('is-open');
      if (this.reduced.matches) {
        this.mnav.close();
        return;
      }
      const panel = this.mnav.querySelector('[data-mnav-panel]');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.mnav.close();
      };
      panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 500);
    }

    finishMobile() {
      this.mnavClosing = false;
      this.mnav.classList.remove('is-open');
      document.documentElement.classList.remove('mnav-open');
      this.menuToggle.setAttribute('aria-expanded', 'false');
      this.menuToggle.focus({ preventScroll: true });
    }
  }

  customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.hero__dot'));
      this.heroSection = this.closest('.hero');
      this.activeIndex = 0;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.slideIndex, 10);
          this.goToSlide(index);
          this.restart();
        });
      });

      if (this.heroSection) {
        this.heroSection.addEventListener('mouseenter', () => this.pause());
        this.heroSection.addEventListener('mouseleave', () => this.restart());
        this.heroSection.addEventListener('focusin', () => this.pause());
        this.heroSection.addEventListener('focusout', (event) => {
          if (!this.heroSection.contains(event.relatedTarget)) this.restart();
        });
      }

      if (!this.reducedMotion) {
        this.play();
      }
    }

    disconnectedCallback() {
      this.pause();
    }

    goToSlide(index) {
      if (index === this.activeIndex) return;
      const current = this.slides[this.activeIndex];
      const next = this.slides[index];

      current.classList.add('hero__slide--inactive');
      current.inert = true;
      next.classList.remove('hero__slide--inactive');
      next.inert = false;

      this.dots.forEach((dot) => {
        const isActive = parseInt(dot.dataset.slideIndex, 10) === index;
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.activeIndex = index;
    }

    play() {
      if (this.timer) return;
      const interval = parseInt(this.dataset.interval, 10) || 7500;
      this.timer = window.setInterval(() => {
        const nextIndex = (this.activeIndex + 1) % this.slides.length;
        this.goToSlide(nextIndex);
      }, interval);
    }

    pause() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      if (this.reducedMotion) return;
      this.pause();
      this.play();
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["life-at-home"] && !Shopify.designMode) return;
  try {
    
  class LifeAtHome extends HTMLElement {
    connectedCallback() {
      this.chapters = Array.from(this.querySelectorAll('[data-chapter]'));
      if (!this.chapters.length) return;

      this.desktop = window.matchMedia('(min-width: 990px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      this.token = 0;
      this.hoverTimer = null;

      this.chapters.forEach((chapter, index) => {
        const trigger = chapter.querySelector('[data-trigger]');
        trigger.addEventListener('click', () => this.isDesktop() && this.select(index));
        trigger.addEventListener('focus', () => this.isDesktop() && this.select(index));
        trigger.addEventListener('pointerenter', (event) => {
          if (!this.isDesktop() || event.pointerType !== 'mouse') return;
          window.clearTimeout(this.hoverTimer);
          this.hoverTimer = window.setTimeout(() => this.select(index), 120);
        });
        trigger.addEventListener('pointerleave', () => window.clearTimeout(this.hoverTimer));
        trigger.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.onChange = () => this.sync();
      this.desktop.addEventListener('change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      window.clearTimeout(this.hoverTimer);
      this.desktop?.removeEventListener('change', this.onChange);
    }

    isDesktop() {
      return this.desktop.matches;
    }

    sync() {
      const desktop = this.isDesktop();
      this.classList.toggle('is-enhanced', desktop);

      if (desktop) {
        this.removeAttribute('tabindex');
        this.render(this.current);
      } else {
        this.tabIndex = 0;
      }

      this.chapters.forEach((chapter, index) => {
        const trigger = chapter.querySelector('[data-trigger]');
        const detail = chapter.querySelector('[data-detail]');
        if (desktop) {
          trigger.setAttribute('role', 'button');
          trigger.tabIndex = 0;
          trigger.setAttribute('aria-controls', detail.id);
          trigger.setAttribute('aria-expanded', String(index === this.current));
        } else {
          trigger.removeAttribute('role');
          trigger.removeAttribute('tabindex');
          trigger.removeAttribute('aria-controls');
          trigger.removeAttribute('aria-expanded');
        }
      });
    }

    render(index) {
      this.chapters.forEach((chapter, i) => {
        const media = chapter.querySelector('.chapter__media');
        chapter.classList.toggle('is-active', i === index);
        media.classList.toggle('is-visible', i === index);
        media.classList.toggle('is-active', i === index);
      });
    }

    async select(index) {
      if (index === this.current) return;
      const token = ++this.token;
      const next = this.chapters[index];
      const nextMedia = next.querySelector('.chapter__media');
      const image = nextMedia.querySelector('.chapter__image');

      // Load only when asked for, then wait (briefly) so the crossfade never shows a blank frame.
      if (image && image.loading === 'lazy') image.loading = 'eager';
      if (image && !image.complete) {
        await Promise.race([image.decode().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 1200))]);
      }
      if (token !== this.token) return;

      const previous = this.chapters[this.current];
      const previousMedia = previous.querySelector('.chapter__media');
      this.current = index;

      nextMedia.classList.add('is-visible');
      void nextMedia.offsetWidth;
      nextMedia.classList.add('is-active');
      previousMedia.classList.remove('is-active');
      window.setTimeout(
        () => {
          if (!previousMedia.classList.contains('is-active')) previousMedia.classList.remove('is-visible');
        },
        this.reduced.matches ? 0 : 600
      );

      this.chapters.forEach((chapter, i) => {
        chapter.classList.toggle('is-active', i === index);
        chapter.querySelector('[data-trigger]').setAttribute('aria-expanded', String(i === index));
      });
    }

    onKeydown(event, index) {
      if (!this.isDesktop()) return;
      const last = this.chapters.length - 1;
      let target = null;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') target = Math.min(index + 1, last);
      else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') target = Math.max(index - 1, 0);
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = last;
      else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.select(index);
        return;
      }

      if (target !== null) {
        event.preventDefault();
        this.chapters[target].querySelector('[data-trigger]').focus();
      }
    }
  }

  if (!customElements.get('life-at-home')) customElements.define('life-at-home', LifeAtHome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments"] && !Shopify.designMode) return;
  try {
    
  class MomentsStage extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.moments = Array.from(this.querySelectorAll('[data-moment]'));
      this.counter = this.querySelector('[data-counter]');
      if (this.tabs.length < 2) return;

      this.desktop = window.matchMedia('(min-width: 990px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      this.token = 0;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
    }

    async select(index, moveFocus) {
      if (moveFocus) this.tabs[index].focus();
      if (index === this.current) return;
      const token = ++this.token;
      const next = this.moments[index];

      // Load the next moment's images while it is still hidden, so it never appears half-drawn.
      next.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
      const scene = next.querySelector('.moments__image');
      if (scene && !scene.complete) {
        await Promise.race([scene.decode().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 1200))]);
      }
      if (token !== this.token) return;

      const previous = this.moments[this.current];
      const crossfade = this.desktop.matches && !this.reduced.matches;
      this.current = index;

      next.hidden = false;
      void next.offsetWidth;
      next.classList.add('is-active');
      previous.classList.remove('is-active');

      const finish = () => {
        this.moments.forEach((moment, i) => {
          if (i !== this.current) moment.hidden = true;
        });
      };
      if (crossfade) window.setTimeout(() => token === this.token && finish(), 600);
      else finish();

      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      if (this.counter) this.counter.textContent = '0' + (index + 1) + ' / 0' + this.tabs.length;
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let target = null;
      if (event.key === 'ArrowRight') target = index === last ? 0 : index + 1;
      else if (event.key === 'ArrowLeft') target = index === 0 ? last : index - 1;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = last;
      if (target === null) return;
      event.preventDefault();
      this.select(target, true);
    }
  }

  if (!customElements.get('moments-stage')) customElements.define('moments-stage', MomentsStage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form.pdp-form');
      this.gallery = this.querySelector('[data-gallery]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.setupQuantity();
      this.setupFinancing();
      this.setupVariants();
      this.setupThumbnails();
      this.setupSticky();
      this.setupCounter();
    }

    // Shopify's payment-terms banner knows which variants are eligible. When it says the selected
    // variant is not, hide the banner rather than show a generic "orders over $X" note. If the
    // data can't be read, the banner simply stays as Shopify renders it.
    setupFinancing() {
      const wrap = this.querySelector('[data-financing]');
      const terms = wrap && wrap.querySelector('shopify-payment-terms');
      if (!terms) return;

      const sync = () => {
        try {
          const meta = JSON.parse(terms.getAttribute('shopify-meta'));
          const field = this.form && this.form.querySelector('[name="id"]');
          const entry = meta.variants.find((variant) => String(variant.id) === String(field && field.value));
          wrap.hidden = Boolean(entry) && entry.eligible === false;
        } catch (error) {
          wrap.hidden = false;
        }
      };

      sync();
      this.form.addEventListener('change', (event) => {
        if (event.target && event.target.name === 'id') window.setTimeout(sync, 0);
      });
    }

    setupQuantity() {
      const input = this.querySelector('[data-qty-input]');
      if (!input) return;
      const step = (delta) => {
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.querySelector('[data-qty-minus]')?.addEventListener('click', () => step(-1));
      this.querySelector('[data-qty-plus]')?.addEventListener('click', () => step(1));
      input.addEventListener('change', () => {
        if (!(parseInt(input.value, 10) >= 1)) input.value = '1';
      });
    }

    setupVariants() {
      const select = this.querySelector('[data-variant-select]');
      if (!select) return;

      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';

        this.querySelector('[data-price]').textContent = option.dataset.price;
        const stickyPrice = this.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;

        const wrap = this.querySelector('[data-price-wrap]');
        let compare = wrap.querySelector('[data-compare]');
        if (option.dataset.compare) {
          if (!compare) {
            compare = document.createElement('s');
            compare.className = 'pdp-buy__price-compare';
            compare.setAttribute('data-compare', '');
            wrap.appendChild(compare);
          }
          compare.textContent = option.dataset.compare;
        } else if (compare) {
          compare.remove();
        }

        [['[data-submit]', '[data-submit-label]'], ['[data-sticky-submit]', '[data-sticky-label]']].forEach(([buttonSel, labelSel]) => {
          const button = this.querySelector(buttonSel);
          const label = this.querySelector(labelSel);
          if (!button || !label) return;
          button.disabled = !available;
          label.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        });

        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      });
    }

    setupThumbnails() {
      const thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      const wrap = this.querySelector('.pdp__gallery');
      if (!wrap || thumbs.length < 2 || this.slides.length < 2) return;

      wrap.classList.add('is-enhanced');
      const counter = this.querySelector('[data-counter]');

      const load = (index) => {
        const image = this.slides[index]?.querySelector('img');
        if (image && image.loading === 'lazy') image.loading = 'eager';
      };

      const select = (index, focus) => {
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        thumbs.forEach((thumb, i) => {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        load(index);
        if (counter) counter.textContent = index + 1 + ' / ' + this.slides.length;
        if (focus) thumbs[index].focus();
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => select(index));
        thumb.addEventListener('pointerenter', () => load(index));
        thumb.addEventListener('focus', () => load(index));
        thumb.addEventListener('keydown', (event) => {
          const last = thumbs.length - 1;
          let target = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = index === last ? 0 : index + 1;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = index === 0 ? last : index - 1;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = last;
          if (target === null) return;
          event.preventDefault();
          select(target, true);
        });
      });
    }

    setupSticky() {
      const bar = this.querySelector('[data-sticky-bar]');
      const anchor = this.form;
      if (!bar || !anchor || !('IntersectionObserver' in window)) return;

      const state = { formGone: false, atEnd: false };
      const show = () => {
        const visible = state.formGone && !state.atEnd;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
        bar.inert = !visible;
      };

      this.stickyObserver = new IntersectionObserver(
        ([entry]) => {
          state.formGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          show();
        },
        { threshold: 0 }
      );
      this.stickyObserver.observe(anchor);

      const end = this.querySelector('[data-sticky-end]');
      if (end) {
        this.endObserver = new IntersectionObserver(
          ([entry]) => {
            state.atEnd = entry.isIntersecting;
            show();
          },
          { threshold: 0 }
        );
        this.endObserver.observe(end);
      }
    }

    setupCounter() {
      const counter = this.querySelector('[data-counter]');
      if (!counter || !this.gallery || this.slides.length < 2 || !('IntersectionObserver' in window)) return;

      this.counterObserver = new IntersectionObserver(
        (entries) => {
          if (window.matchMedia('(min-width: 990px)').matches) return;
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              counter.textContent = this.slides.indexOf(entry.target) + 1 + ' / ' + this.slides.length;
            }
          });
        },
        { root: this.gallery, threshold: 0.6 }
      );
      this.slides.forEach((slide) => this.counterObserver.observe(slide));
    }

    disconnectedCallback() {
      this.stickyObserver?.disconnect();
      this.endObserver?.disconnect();
      this.counterObserver?.disconnect();
    }
  }

  if (!customElements.get('product-page')) customElements.define('product-page', ProductPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  class WelcomePopup extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('.welcome-popup__card');
      this.form = this.querySelector('form');
      if (!this.card || !this.form) return;

      this.keys = {
        dismissed: 'careway_welcome_dismissed_until',
        impressions: 'careway_welcome_impressions',
        subscribed: 'careway_welcome_subscribed',
        session: 'careway_welcome_shown_session',
      };
      this.delay = (parseInt(this.dataset.delay, 10) || 14) * 1000;
      this.engagedDelay = (parseInt(this.dataset.engagedDelay, 10) || 8) * 1000;
      this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 30;
      this.maxImpressions = parseInt(this.dataset.maxImpressions, 10) || 3;
      this.connected = this.dataset.connected === 'true';
      this.sending = false;
      this.sent = false;
      this.lastAddToCart = 0;
      this.visibleMs = 0;
      this.isOpen = false;

      const params = new URLSearchParams(window.location.search);
      if (params.has('welcome_popup_reset')) this.resetMemory();
      if (params.has('welcome_popup_now')) {
        this.delay = 1500;
        this.engagedDelay = 1500;
      }

      this.querySelectorAll('[data-welcome-close]').forEach((button) => button.addEventListener('click', () => this.close()));
      this.card.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.form.addEventListener('input', () => this.clearError());

      // Give a shopper who is adding to the cart room to finish.
      document.addEventListener('submit', (event) => {
        if (event.target.matches && event.target.matches('form[action*="/cart/add"]')) this.lastAddToCart = Date.now();
      });

      // A form posted without JavaScript comes back with Shopify's own success marker.
      if (this.querySelector('[data-welcome-posted]')) {
        this.sent = true;
        this.write(window.localStorage, this.keys.subscribed, 'true');
        this.showSuccess();
        this.open();
        return;
      }

      if (!this.canShow()) return;
      this.start();
    }

    read(storage, key) {
      try {
        return storage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    write(storage, key, value) {
      try {
        storage.setItem(key, value);
      } catch (error) {
        // Private windows and blocked storage simply mean nothing is remembered.
      }
    }

    resetMemory() {
      try {
        Object.values(this.keys).forEach((key) => {
          window.localStorage.removeItem(key);
          window.sessionStorage.removeItem(key);
        });
      } catch (error) {
        // Nothing to reset.
      }
    }

    canShow() {
      if (this.read(window.localStorage, this.keys.subscribed) === 'true') return false;
      if (Date.now() < parseInt(this.read(window.localStorage, this.keys.dismissed) || '0', 10)) return false;
      if (parseInt(this.read(window.localStorage, this.keys.impressions) || '0', 10) >= this.maxImpressions) return false;
      if (this.read(window.sessionStorage, this.keys.session) === 'true') return false;
      return true;
    }

    // Time only counts while the tab is visible, so a background tab never triggers it.
    start() {
      this.timer = window.setInterval(() => {
        if (document.hidden) return;
        this.visibleMs += 1000;
        const scrolled = (window.scrollY + window.innerHeight) / Math.max(document.documentElement.scrollHeight, 1);
        const engaged = this.visibleMs >= this.engagedDelay && scrolled >= 0.5;
        if (this.visibleMs >= this.delay || engaged) this.tryOpen();
      }, 1000);
    }

    busy() {
      if (document.querySelector('dialog[open]')) return true;
      if (document.querySelector('[data-mnav][open]')) return true;
      if (Date.now() - this.lastAddToCart < 20000) return true;
      const active = document.activeElement;
      return Boolean(active && active !== document.body && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName) && !this.contains(active));
    }

    tryOpen() {
      if (this.isOpen || this.busy() || !this.canShow()) return;
      window.clearInterval(this.timer);
      this.open();
    }

    // On product pages the mobile sticky Add to cart bar sits at the bottom; stay above it.
    updateOffset() {
      const bar = document.querySelector('.pdp-sticky.is-visible');
      this.style.setProperty('--welcome-popup-offset', bar ? bar.offsetHeight + 'px' : '0px');
    }

    open() {
      this.isOpen = true;
      this.hidden = false;
      this.updateOffset();
      this.onScroll = () => window.requestAnimationFrame(() => this.updateOffset());
      window.addEventListener('scroll', this.onScroll, { passive: true });
      const bar = document.querySelector('.pdp-sticky');
      if (bar) {
        this.barObserver = new MutationObserver(() => this.updateOffset());
        this.barObserver.observe(bar, { attributes: true, attributeFilter: ['class'] });
      }
      window.setTimeout(() => this.classList.add('is-visible'), 20);
      this.write(window.sessionStorage, this.keys.session, 'true');
      const seen = parseInt(this.read(window.localStorage, this.keys.impressions) || '0', 10) + 1;
      this.write(window.localStorage, this.keys.impressions, String(seen));
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-visible');
      window.removeEventListener('scroll', this.onScroll);
      if (this.barObserver) this.barObserver.disconnect();
      this.write(window.localStorage, this.keys.dismissed, String(Date.now() + this.dismissDays * 86400000));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(() => {
        this.hidden = true;
      }, reduce ? 0 : 220);
    }

    showError(message) {
      const error = this.querySelector('[data-welcome-error]');
      const input = this.querySelector('[data-welcome-email]');
      error.textContent = message;
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }

    clearError() {
      const error = this.querySelector('[data-welcome-error]');
      const input = this.querySelector('[data-welcome-email]');
      error.hidden = true;
      input.removeAttribute('aria-invalid');
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.sending || this.sent) return;
      const input = this.querySelector('[data-welcome-email]');
      const value = input.value.trim();
      if (!value) return this.showError(this.dataset.messageMissing);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return this.showError(this.dataset.messageInvalid);
      this.clearError();

      // Preview mode: nothing is sent and the popup says so.
      if (!this.connected) {
        this.querySelector('[data-welcome-preview-note]').hidden = false;
        return;
      }
      this.send();
    }

    // Posts to Shopify's customer form. Success is whatever Shopify itself reports; if Shopify asks for
    // a spam challenge, the form is submitted normally so the visitor can complete it.
    async send() {
      const button = this.form.querySelector('button[type="submit"]');
      this.sending = true;
      button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });
        if (response.url.indexOf('/challenge') !== -1) {
          this.form.submit();
          return;
        }
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const posted = response.url.indexOf('customer_posted=true') !== -1 || page.querySelector('welcome-popup [data-welcome-posted]');
        if (!response.ok || !posted) throw new Error('not posted');
        this.sent = true;
        this.write(window.localStorage, this.keys.subscribed, 'true');
        this.showSuccess();
      } catch (error) {
        this.sending = false;
        button.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.showError(this.dataset.messageFailed);
      }
    }

    showSuccess() {
      this.querySelectorAll('[data-welcome-hide-on-success]').forEach((element) => {
        element.hidden = true;
      });
      this.form.hidden = true;
      this.querySelector('.welcome-popup__title').textContent = this.dataset.successHeading;
      const decline = this.querySelector('.welcome-popup__decline');
      if (decline && this.dataset.successClose) decline.textContent = this.dataset.successClose;
      const success = this.querySelector('[data-welcome-success]');
      success.hidden = false;
      if (this.isOpen) success.focus();
    }
  }

  if (!customElements.get('welcome-popup')) customElements.define('welcome-popup', WelcomePopup);

  } catch(e) { console.error(e); }
})();
})();
